var _path, _path2, _g, _rect, _rect2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRelioAppLogoWithName = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 168,
    viewBox: "0 0 539 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M524.052 45.3446V46.8903H519.664V58.3674H517.887V46.8903H513.499V45.3446H524.052V45.3446Z",
    fill: "#0093D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M525.614 45.3447H528.137L531.885 56.3598L535.599 45.3447H538.104V58.3675H536.416V50.6746C536.416 50.4081 536.416 49.9639 536.434 49.3599C536.434 48.738 536.434 48.0807 536.434 47.3878L532.721 58.3675H530.979L527.231 47.3878V47.7787C527.231 48.0985 527.231 48.5782 527.248 49.2355C527.248 49.8929 527.266 50.3726 527.266 50.6746V58.3675H525.578V45.3447H525.614Z",
    fill: "#0093D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2355_1827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.1 57.7251L262.172 76.42C262.172 76.42 258.361 74.5068 251.26 74.5432C239.83 74.5979 233.891 81.0117 233.927 89.7396L234.142 141.415L214.34 141.506L214 57.9073L233.802 57.8162L233.855 70.4252C235.93 64.3394 242.62 55.8119 251.189 55.7755C255.034 55.7755 258.701 56.4496 262.118 57.7251H262.1Z",
    fill: "#0093D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.642 104.681L288.842 104.936C290.845 118.62 299.986 125.125 309.323 125.216C315.548 125.107 321.666 122.137 325.601 116.106L347.21 116.015C341.253 133.197 326.084 142.781 309.395 142.982C287.822 142.891 268.647 127.202 268.54 99.3604C268.432 71.5185 287.912 55.484 309.037 55.3928C330.163 55.3017 349.785 71.2452 349.893 99.0142C349.893 100.964 349.821 102.841 349.642 104.663V104.681ZM328.946 89.4299C324.85 78.7341 317.605 73.3042 309.127 73.1949C300.63 73.3589 293.421 78.8252 289.414 89.5939L328.946 89.4299Z",
    fill: "#0093D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.809 140.868L363.344 27.4963L383.146 27.4052L383.611 140.777L363.809 140.868Z",
    fill: "#0093D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.248 140.704L400.908 57.1421L420.71 57.051L421.05 140.613L401.248 140.704Z",
    fill: "#0093D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.103 98.2671C515.211 126.018 496.178 141.961 474.606 142.235C453.033 142.144 433.858 126.455 433.75 98.6134C433.643 70.7715 453.123 54.7369 474.248 54.6458C495.373 54.5547 514.996 70.5164 515.103 98.2671ZM495.212 98.3582C495.141 81.9957 485.106 72.5754 474.319 72.4478C463.533 72.6665 453.57 82.0868 453.641 98.5405C453.713 116.087 463.998 124.378 474.534 124.469C485.07 124.287 495.284 115.923 495.212 98.3765V98.3582Z",
    fill: "#0093D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8 48.9426C417.103 48.9426 422.213 43.5828 422.213 36.9713C422.213 30.3597 417.103 25 410.8 25C404.497 25 399.388 30.3597 399.388 36.9713C399.388 43.5828 404.497 48.9426 410.8 48.9426Z",
    fill: "#0093D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 168,
    rx: 36,
    fill: "#0093D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44.6582,
    width: 39.3418,
    height: 89.3165,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.924,
    cy: 52.1012,
    r: 22.3291,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2355_1827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301.103,
    height: 118,
    fill: "white",
    transform: "translate(214 25)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRelioAppLogoWithName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/relio-app-logo-with-name.4a0ade4ce38ed79202dcb482c2e645ac.svg";